import { API } from "@/lib/api";

export function fileDownloadUrl(fileId) {
  const token = localStorage.getItem("evo_token");
  return `${API}/files/${fileId}/download?auth=${encodeURIComponent(token || "")}`;
}

export async function uploadToProject({ projectId, admin = false, kind = "document", file, docType = "other", caption = "" }) {
  const token = localStorage.getItem("evo_token");
  const fd = new FormData();
  fd.append("file", file);
  fd.append("caption", caption);
  let url;
  if (kind === "photo") url = `${API}/admin/projects/${projectId}/photos`;
  else {
    fd.append("doc_type", docType);
    url = admin ? `${API}/admin/projects/${projectId}/documents` : `${API}/projects/${projectId}/documents`;
  }
  const res = await fetch(url, { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Upload failed");
  }
  return res.json();
}

export function humanSize(bytes) {
  if (!bytes) return "";
  const units = ["B", "KB", "MB"];
  let i = 0, n = bytes;
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}
